import { BadgeColor } from '../../enums';

export type EnumValues<T> = T[keyof T];

export class StatusBadgePipe<
  StatusEnum extends Record<string, string | number>,
  ColorEnum extends Record<string, string | number>,
> {
  private config: Record<EnumValues<StatusEnum>, { badge: BadgeColor; label: string }> = {} as any;

  constructor(
    private statusEnum: StatusEnum,
    private badgeColorEnum: ColorEnum,
  ) {
    this.buildConfig();
  }

  private buildConfig() {
    const keys = Object.keys(this.statusEnum) as Array<keyof StatusEnum>;
    keys.forEach((key) => {
      const statusValue = this.statusEnum[key] as EnumValues<StatusEnum>;
      const badgeValue = this.badgeColorEnum[key as keyof ColorEnum] as EnumValues<ColorEnum>;
      this.config[statusValue] = {
        badge: badgeValue as BadgeColor,
        label: `STATUS_${(statusValue as string).toUpperCase()}`,
      };
    });
  }

  transform(status?: EnumValues<StatusEnum>): { badge: BadgeColor; label: string } | null {
    if (!status) return null;
    return this.config[status] ?? null;
  }
}
